import React, { useState, useEffect } from 'react';
import { Lock } from 'lucide-react';
import styles from './form.module.css';

const DEFAULT_REACTIONS = ['👍', '❤️', '😂', '😮', '👎'];

const ReactionForm = ({ content, onSubmit, isPreview = false, isLocked = false, userAnswer = null, allowUpdateResponse = true }) => {
    const options = content?.options?.length ? content.options : DEFAULT_REACTIONS;
    const [selected, setSelected] = useState(() => userAnswer?.reaction || null);

    useEffect(() => {
        setSelected(userAnswer?.reaction || null);
    }, [userAnswer]);

    const hasSubmitted = userAnswer != null;
    const isDisabled = isLocked || (hasSubmitted && !allowUpdateResponse);
    const isUnchanged = hasSubmitted && selected === userAnswer.reaction;
    const submitDisabled = isPreview || isLocked || !selected || (hasSubmitted && (!allowUpdateResponse || isUnchanged));
    const submitLabel = !hasSubmitted ? (isLocked ? 'Voting Closed' : 'Submit') : (!allowUpdateResponse || isUnchanged ? 'Submitted ✓' : 'Update response');

    const handleSubmit = () => {
        if (submitDisabled) return;
        onSubmit({ reaction: selected });
    };

    return (
        <div className={styles.form}>
            <div className={styles.question}>
                {content.question || 'React with an emoji'}
                {isLocked && <span className={styles.lockBadge}><Lock size={12} aria-hidden="true" /> Voting Locked</span>}
            </div>
            {content.settings?.description && content.settings?.descText && (
                <div className={styles.description}>{content.settings.descText}</div>
            )}
            <div className={styles.reactionGrid}>
                {options.map((emoji) => (
                    <button
                        key={emoji}
                        type="button"
                        className={`${styles.reactionBtn} ${selected === emoji ? styles.selected : ''}`}
                        onClick={() => !isDisabled && setSelected(emoji)}
                        disabled={isDisabled}
                        aria-label={emoji}
                        aria-pressed={selected === emoji}
                    >
                        {emoji}
                    </button>
                ))}
            </div>
            <button className={styles.submitBtn} onClick={handleSubmit} disabled={submitDisabled}>
                {submitLabel}
            </button>
        </div>
    );
};

export default ReactionForm;
